<template>
	<div>
		<el-row>
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
				<div class="content_main clearfix">
					<div class="newslist right-main">
						<div class="nav-btn">
							<div v-for="(item,index) in navList">
								<router-link :class="item.title==current ? 'nav-btn-active' : ''" v-if="item.list_type==1" :to="`/rules?id=${item.id}&name=${item.title}`">
									{{item.title}}
								</router-link>
								<router-link :class="item.title==current ? 'nav-btn-active' : ''" v-else :to="`/news?id=${item.id}&name=${item.title}`">
									{{item.title}}
								</router-link>
							</div>
						</div>
						<ul class="jjbq-box newslist3">
							<li class="clearfix" v-for="(item,index) in list">
								<div class="news-box clearfix">
									<div class="news_pic"></div>
									<div class="news_font">
										<div class="news-dbo">
											<h2>
												<router-link :to="`/newsdetail?id=${item.id}`">
												{{item.title}}</router-link>
											</h2>
											<router-link :to="`/newsdetail?id=${item.id}`">
												<p v-html="item.desc"></p>
											</router-link>
										</div>
										<div class="news_ly">
											<span>时间：{{item.created_at | time}}</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</el-col>
			<el-col class="btm-btn" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
				<div @click="change('index')">首页</div>
				<div @click="change('desc')">前一页</div>
				<div @click="change('add')">后一页</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import moment from '@/utils/moment';
	import {
		Adv
	} from '@/api/adv';
	var adv = new Adv();
	export default{
		data(){
			return{
				current:'',
				id:'',
				list:[],
				navList:[],
				page:1,
				per_page:10
				
			}
		},
		created() {
			this.id=this.$route.query.id;
			this.current=this.$route.query.name;
			this.getNavBar();
			this.getList();
		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD HH:mm');
			},
		},
		watch: {
			$route(to, from) {
				if (to.query.id != from.query.id) {
					this.list=[];
					this.id=to.query.id;
					this.current=to.query.name;
					this.getList();
				}
			}
		},
		methods:{
			//
			getNavBar(){
				var that = this;
				var param = {};
				adv.navbar(param).then(data => {
					that.navList = that.navList.concat(data.data);
				}).catch((res) => {
				});
			},
			//分类
			getList(){
				var that = this;
				var param = {
					'per-page':this.per_page,
					page:this.page,
					navbar_item_id:this.id
				};
				adv.navList(param).then(data => {
					that.list = that.list.concat(data.data);
				}).catch((res) => {
				});
			},
			change(type){
				if(type=='desc'){
					if(this.page==1){
						this.$message({
						  message: '已是第一页',
						  type: 'warning'
						});
					}else{
						this.list=[];
						this.page--;
						this.getList();
					}
				} else if(type == 'add') {
					this.list = [];
					this.page++;
					this.getList();
				}else if(type == 'index'){
					this.list = [];
					this.page=1;
					this.getList();
				}
			}
		}
	}
</script>

<style>
	.content_main {
		width: 100%;
		padding-top: 10px;
	}
	.nav-btn{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.nav-btn a{
		color: #2c3096;
		font-size: 14px;
		line-height: 35px;
		padding: 0 12px;
		display: block;
		border: 1px solid #2c3096;
		border-radius: 5px;
		margin: 0 4px 8px;
		cursor: pointer;
	}
	.nav-btn-active{
		background: #2c3096;
		color: #fff !important;
	}
	.news-box p {
	    color: #7b7b7b;
	    font-size: 14px;
	    line-height: 24px;
	    text-overflow: ellipsis;
	    display: -webkit-box;
	    -webkit-box-orient: vertical;
	    -webkit-line-clamp: 2;
	    overflow: hidden;
	    word-break: break-all;
	}

	.newslist3 {
		margin-bottom: 20px;
	}

	.jjbq-box {
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		list-style: none !important;
		padding: 0 10px !important;
	}

	ul,
	ol {
		padding-left: 0;
		margin: 0;
	}

	.newslist .newslist3 li {
		width: 100%;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 1px dashed #d0d4d1;
	}

	.jjbq-box li {
		-webkit-box-flex: 0;
	}

	.news-box {
		width: 100%;
	}

	.news_pic {
		width: 100%;
		margin-bottom: 15px;
	}

	.news-box h2 {
		line-height: 30px;
		font-size: 15px;
		margin-bottom: 5px;
	}

	.news-box p {
		color: #7b7b7b;
		font-size: 14px;
		line-height: 24px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		word-break: break-all;
	}

	.news-box .news_ly {
		margin-top: 15px;
	}

	.news-box .news_ly span {
		color: #777;
		font-size: 14px;
		line-height: 20px;
		padding-right: 20px;
	}
	.news-dbo h2 a{
		color: #2c3096 !important;
	}
	.el-pagination{
		margin: 20px 0 !important;
	}
	.btm-btn{
		display: flex;
		justify-content: space-around;
		margin-bottom: 20px;
		align-items: center;
	}
	.btm-btn div{
		padding: 0 15px;
		height: 30px;
		border: 1px solid #e4e4e4;
		line-height: 30px;
		background: #fff;
		color: #666666;
		font-size: 13px;
		border-radius: 4px;
	}
</style>